import React from 'react'
import { observer } from 'mobx-react'
import RateProDialogViewModel from './RateProDialogViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { FormRow, TextAreaContainer } from 'components/inputs'
import Button from 'components/Button'
import Avatar from 'components/Avatar'
import styles from './RateProDialogViewModel.sass'
import ThumbsRating from '../components/ThumbsRating'
import StarRating from '../../../components/StarRating'
import { match } from '../../../utils/pattern-match-util'

interface Props {
  vm: RateProDialogViewModel
}

export default observer(function RateProDialog({ vm }: Props) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <div className={styles.avatar}>
            <Avatar
              subject={vm.proChampion?.member}
              size={112}
              backgroundColor="#40A0F4"
            ></Avatar>
          </div>

          <ModalSheetContentTitle>
            How was {vm.proChampion?.member.givenName}'s service?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Our Pros appreciate your reviews.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <FormRow>
            {match(vm.ratingMethod, {
              stars: () => (
                <StarRating
                  iconName="star2"
                  iconSize={56}
                  value={vm.rating}
                  onChange={vm.setRating}
                ></StarRating>
              ),
              thumbs: () => (
                <ThumbsRating
                  iconSize={32}
                  value={vm.thumbsRating}
                  onChange={vm.setThumbsRating}
                />
              ),
            })}
          </FormRow>
          <FormRow>
            <TextAreaContainer
              rows={3}
              label="Add a written review"
              placeholder="Tell us more about your experience."
              help="This feedback is optional."
              model={vm}
              field="feedback"
              name="feedback"
              data-test="rate-pro-feedback"
            />
          </FormRow>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            onClick={vm.close}
            disabled={vm.ratePro.pending}
            data-test="rate-pro-close-button"
          >
            Close
          </Button>
          <Button
            type="primary"
            onClick={vm.ratePro}
            data-test="rate-pro-submit-button"
            loading={vm.ratePro.pending}
            disabled={!vm.validRating}
          >
            Submit Feedback
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
